var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var IdentityManager = /*#__PURE__*/function () {
  "use strict";

  function IdentityManager() {
    var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, IdentityManager);

    this._providers = providers;
  }

  _createClass(IdentityManager, [{
    key: "addProviderSettings",
    value: function addProviderSettings(providerSettings) {
      var url = providerSettings.provider.url;
      var provider = this._providers[url] || (this._providers[url] = {});
      provider.providerSettings = providerSettings;
    }
  }, {
    key: "getProviderSettings",
    value: function getProviderSettings(url) {
      return this._providers[url] && this._providers[url].providerSettings;
    }
  }, {
    key: "addSession",
    value: function addSession(providerSettings, username, session) {
      this.getSessions(providerSettings)[username] = session;
    }
  }, {
    key: "getSession",
    value: function getSession(providerSettings, username) {
      return this.getSessions(providerSettings)[username];
    }
  }, {
    key: "getSessions",
    value: function getSessions(providerSettings) {
      var url = providerSettings.provider.url;
      var provider = this._providers[url] || (this._providers[url] = {});
      var sessions = provider.sessions || (provider.sessions = {});
      return sessions;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return JSON.stringify({
        providers: this._providers
      });
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      var _JSON$parse = JSON.parse(json),
          providers = _JSON$parse.providers;

      return new IdentityManager(providers || {});
    }
  }]);

  return IdentityManager;
}();

module.exports = IdentityManager;